import { useState } from "react"
import { Link } from "react-router-dom"
import { navbar } from "../data/data"
import { FaBars } from "react-icons/fa"
import CreateAccountLight from "../utils/CreateAccountLight"

export default function Navbar() {
  const [links] = useState(navbar)

  const handleClick = () => {
    const navbar = document.querySelector(".navbar")

    navbar.classList.toggle("open")
  }

  return (
    <>
      <nav className="navbar">
        <ul>
          {links.map(({ id, title, url }) => (
            <li key={id} onClick={handleClick}>
              <Link to={url}>{title}</Link>
            </li>
          ))}
          <div>
            <ul className="flex lg:items-center">
              <li>
                <button className="uppercase font-bold lg:capitalize lg:font-light">
                  Sign In
                </button>
              </li>
              <li className="ml-5">
                <CreateAccountLight />
              </li>
            </ul>
          </div>
        </ul>
      </nav>

      <button
        onClick={handleClick}
        className="lg:hidden focus:outline-dotted outline-blue-400 p-1"
      >
        <FaBars className="text-white text-3xl" />
      </button>
    </>
  )
}
